import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    locked: { type: Boolean, default: false }
  }

  connect() {
    this.boundReset = this.reset.bind(this)

    document.addEventListener("turbo:load", this.boundReset)
    window.addEventListener("pageshow", this.boundReset)

    if (this.lockedValue) {
      this.applyLock()
    }
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.boundReset)
    window.removeEventListener("pageshow", this.boundReset)
  }

  lock(event) {
    if (this.lockedValue) {
      event?.preventDefault()
      return false
    }

    this.applyLock()
  }

  reset() {
    this.lockedValue = false
    this.removeLock()
  }

  applyLock() {
    this.lockedValue = true

    if ("disabled" in this.element) {
      this.element.disabled = true
    } else {
      this.element.dataset.locked = "true"
    }
  }

  removeLock() {
    this.lockedValue = false

    if ("disabled" in this.element) {
      this.element.disabled = false
    } else {
      this.element.dataset.locked = "false"
    }
  }
}
